import styled from 'styled-components';

export const Container = styled.div`
  display: table; 
  margin 0 auto;
  margin-bottom: 300px;

`;
